import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppAlert, LazyContextMenuCell, LazyGeneratesWidget, LazyImageLayout, LazyJivoButton, LazyLoadingDots, LazyNewTextarea, LazyProjectDivider, LazySnippetLink, LazyTelegramPopup, LazyTitleLayout, LazyVAccordion, LazyVBadge, LazyVButton, LazyVDivider, LazyVFooter, LazyVInput, LazyVLabel, LazyVLoader, LazyVPlaceholder, LazyVSkeleton, LazyVSpinner, LazyVTag, LazyVTextarea, LazyAuthHeader, LazyAuthModal, LazyAuthLoginForm, LazyAuthPasswordInput, LazyAuthRegisterForm, LazyAuthVAuth, LazyAuthVRecoverPassword, LazyAuthVkAuthButton, LazyAuthYandexAuthButton, LazyCardsPageSideCard, LazyCardsProjectCard, LazyCardsReviewCard, LazyCardsSubjectTopicCard, LazyCardsTariffCard, LazyCardsTopicCard, LazyCommonCardCommon, LazyCommonFilePicture, LazyCommonOptimizedImage, LazyCommonSkeletonLoader, LazyCommonTinkoffBadge, LazyCommonVAlert, LazyCommonVChip, LazyCommonVCollapse, LazyCommonVDialog, LazyCommonVDrawer, LazyCommonVDropdown, LazyCommonVLoader, LazyCommonVModal, LazyCommonVSpinner, LazyCommonVSwitch, LazyCommonVTabs, LazyCommonFormCheckboxListField, LazyCommonFormMaskedInput, LazyCommonFormVButton, LazyCommonFormVCheckbox, LazyCommonFormVInput, LazyCommonFormVRadio, LazyCommonFormVSelect, LazyCommonFormVTextarea, LazyHeader, LazyHeaderCommonHeaderAvatar, LazyHeaderCommonHeaderLogo, LazyHeaderCommonHeaderPlugins, LazyHeaderDesktop, LazyHeaderDesktopDropdown, LazyHeaderDesktopNavbar, LazyHeaderLoyaltyButton, LazyHeaderMobile, LazyPagesIndexLastProjects, LazyPagesIndexVAdvantages, LazyPagesIndexVCreate, LazyPagesIndexVFaq, LazyPagesIndexVFeedback, LazyPagesIndexVPrice, LazyPagesIndexVPromo, LazyPagesLoyaltyLevels, LazyPagesLoyaltyNoTransactionsYet, LazyPagesLoyaltyTransactions, LazyPagesLoyaltyUtils, LazyPagesProfileLoyalty, LazyPagesProjectsChangeStructureButton, LazyPagesProjectsFloatingRateCard, LazyPagesProjectsProject, LazyPagesProjectsProjectAdminPanel, LazyPagesProjectsProjectGeneratingLoader, LazyPagesProjectsProjectMain, LazyPagesProjectsProjectMainDownload, LazyPagesProjectsProjectMeta, LazyPagesProjectsProjectPageSide, LazyPagesProjectsPromocodeInput, LazyPagesProjectsSimilarProjects, LazyPagesProjectsTItlePage, LazyPagesProjectsActionBlock, LazyPagesProjectsActionBlockSkeleton, LazyPagesProjectsActionBlockTimer, LazyPagesProjectsActionBlockCopyActionBlock, LazyPagesProjectsActionBlockFixedActionBlock, LazyPagesProjectsActionBlockPaymentActionBlock, LazyPagesProjectsActionBlockPaymentPendingBlock, LazyPagesProjectsActionBlockPromocodeModalButton, LazyPagesProjectsContentProjectContent, LazyPagesProjectsContentProjectContentItem, LazyPagesProjectsContentProjectContentTitle, LazyPagesProjectsContentRu, LazyPagesProjectsContentVariantsContentBlurred, LazyPagesProjectsContentVariantsContentEditable, LazyPagesProjectsContentVariantsContentGenerating, LazyPagesProjectsContentVariantsContentText, LazyPagesProjectsContentVariantsEditorjsToolsEditorJsMath, LazyPagesProjectsContentVariantsEditorjsToolsEditorJsMathTool, LazyPagesProjectsContentList, LazyPagesProjectsContentListItem, LazyPagesProjectsContentListButtonsContentListItemLeftButtons, LazyPagesProjectsContentListButtonsContentListItemRightButtons, LazyPagesProjectsContentListModalsContentListAddModal, LazyPagesProjectsContentListModalsContentListDeleteModal, LazyPagesProjectsContentListModalsContentListLastParagraphWarning, LazyPagesProjectsContentListModalsContentListRegenerateModal, LazyPagesProjectsContentListTypes, LazyPagesProjectsDownloadButtonsDownloadDocument, LazyPagesProjectsDownloadButtonsDownloadPresentation, LazyPagesProjectsPaymentCopyButton, LazyPagesProjectsPaymentNewPaymentButton, LazyPagesProjectsPaymentButton, LazyPagesProjectsPaymentDropdownButton, LazyPagesProjectsPaymentErrorModal, LazyPagesProjectsPaymentBonusesButton, LazyPagesProjectsPaymentBonusesModal, LazyPromoRefundDetailsPopup, LazyRatingRateModal, LazyRatingReviewRating, LazyRatingSorryModal, LazyRatingStarRatingIconStar, LazyRatingStarRatingOtzovikModal, LazyRatingStarRating, LazyTopicsSubjectTopics, LazyTopicsVTopics, LazyUserAccountModal, LazyUserDeleteRequest } from '#components'
const lazyGlobalComponents = [
  ["AppAlert", LazyAppAlert],
["ContextMenuCell", LazyContextMenuCell],
["GeneratesWidget", LazyGeneratesWidget],
["ImageLayout", LazyImageLayout],
["JivoButton", LazyJivoButton],
["LoadingDots", LazyLoadingDots],
["NewTextarea", LazyNewTextarea],
["ProjectDivider", LazyProjectDivider],
["SnippetLink", LazySnippetLink],
["TelegramPopup", LazyTelegramPopup],
["TitleLayout", LazyTitleLayout],
["VAccordion", LazyVAccordion],
["VBadge", LazyVBadge],
["VButton", LazyVButton],
["VDivider", LazyVDivider],
["VFooter", LazyVFooter],
["VInput", LazyVInput],
["VLabel", LazyVLabel],
["VLoader", LazyVLoader],
["VPlaceholder", LazyVPlaceholder],
["VSkeleton", LazyVSkeleton],
["VSpinner", LazyVSpinner],
["VTag", LazyVTag],
["VTextarea", LazyVTextarea],
["AuthHeader", LazyAuthHeader],
["AuthModal", LazyAuthModal],
["AuthLoginForm", LazyAuthLoginForm],
["AuthPasswordInput", LazyAuthPasswordInput],
["AuthRegisterForm", LazyAuthRegisterForm],
["AuthVAuth", LazyAuthVAuth],
["AuthVRecoverPassword", LazyAuthVRecoverPassword],
["AuthVkAuthButton", LazyAuthVkAuthButton],
["AuthYandexAuthButton", LazyAuthYandexAuthButton],
["CardsPageSideCard", LazyCardsPageSideCard],
["CardsProjectCard", LazyCardsProjectCard],
["CardsReviewCard", LazyCardsReviewCard],
["CardsSubjectTopicCard", LazyCardsSubjectTopicCard],
["CardsTariffCard", LazyCardsTariffCard],
["CardsTopicCard", LazyCardsTopicCard],
["CommonCardCommon", LazyCommonCardCommon],
["CommonFilePicture", LazyCommonFilePicture],
["CommonOptimizedImage", LazyCommonOptimizedImage],
["CommonSkeletonLoader", LazyCommonSkeletonLoader],
["CommonTinkoffBadge", LazyCommonTinkoffBadge],
["CommonVAlert", LazyCommonVAlert],
["CommonVChip", LazyCommonVChip],
["CommonVCollapse", LazyCommonVCollapse],
["CommonVDialog", LazyCommonVDialog],
["CommonVDrawer", LazyCommonVDrawer],
["CommonVDropdown", LazyCommonVDropdown],
["CommonVLoader", LazyCommonVLoader],
["CommonVModal", LazyCommonVModal],
["CommonVSpinner", LazyCommonVSpinner],
["CommonVSwitch", LazyCommonVSwitch],
["CommonVTabs", LazyCommonVTabs],
["CommonFormCheckboxListField", LazyCommonFormCheckboxListField],
["CommonFormMaskedInput", LazyCommonFormMaskedInput],
["CommonFormVButton", LazyCommonFormVButton],
["CommonFormVCheckbox", LazyCommonFormVCheckbox],
["CommonFormVInput", LazyCommonFormVInput],
["CommonFormVRadio", LazyCommonFormVRadio],
["CommonFormVSelect", LazyCommonFormVSelect],
["CommonFormVTextarea", LazyCommonFormVTextarea],
["Header", LazyHeader],
["HeaderCommonHeaderAvatar", LazyHeaderCommonHeaderAvatar],
["HeaderCommonHeaderLogo", LazyHeaderCommonHeaderLogo],
["HeaderCommonHeaderPlugins", LazyHeaderCommonHeaderPlugins],
["HeaderDesktop", LazyHeaderDesktop],
["HeaderDesktopDropdown", LazyHeaderDesktopDropdown],
["HeaderDesktopNavbar", LazyHeaderDesktopNavbar],
["HeaderLoyaltyButton", LazyHeaderLoyaltyButton],
["HeaderMobile", LazyHeaderMobile],
["PagesIndexLastProjects", LazyPagesIndexLastProjects],
["PagesIndexVAdvantages", LazyPagesIndexVAdvantages],
["PagesIndexVCreate", LazyPagesIndexVCreate],
["PagesIndexVFaq", LazyPagesIndexVFaq],
["PagesIndexVFeedback", LazyPagesIndexVFeedback],
["PagesIndexVPrice", LazyPagesIndexVPrice],
["PagesIndexVPromo", LazyPagesIndexVPromo],
["PagesLoyaltyLevels", LazyPagesLoyaltyLevels],
["PagesLoyaltyNoTransactionsYet", LazyPagesLoyaltyNoTransactionsYet],
["PagesLoyaltyTransactions", LazyPagesLoyaltyTransactions],
["PagesLoyaltyUtils", LazyPagesLoyaltyUtils],
["PagesProfileLoyalty", LazyPagesProfileLoyalty],
["PagesProjectsChangeStructureButton", LazyPagesProjectsChangeStructureButton],
["PagesProjectsFloatingRateCard", LazyPagesProjectsFloatingRateCard],
["PagesProjectsProject", LazyPagesProjectsProject],
["PagesProjectsProjectAdminPanel", LazyPagesProjectsProjectAdminPanel],
["PagesProjectsProjectGeneratingLoader", LazyPagesProjectsProjectGeneratingLoader],
["PagesProjectsProjectMain", LazyPagesProjectsProjectMain],
["PagesProjectsProjectMainDownload", LazyPagesProjectsProjectMainDownload],
["PagesProjectsProjectMeta", LazyPagesProjectsProjectMeta],
["PagesProjectsProjectPageSide", LazyPagesProjectsProjectPageSide],
["PagesProjectsPromocodeInput", LazyPagesProjectsPromocodeInput],
["PagesProjectsSimilarProjects", LazyPagesProjectsSimilarProjects],
["PagesProjectsTItlePage", LazyPagesProjectsTItlePage],
["PagesProjectsActionBlock", LazyPagesProjectsActionBlock],
["PagesProjectsActionBlockSkeleton", LazyPagesProjectsActionBlockSkeleton],
["PagesProjectsActionBlockTimer", LazyPagesProjectsActionBlockTimer],
["PagesProjectsActionBlockCopyActionBlock", LazyPagesProjectsActionBlockCopyActionBlock],
["PagesProjectsActionBlockFixedActionBlock", LazyPagesProjectsActionBlockFixedActionBlock],
["PagesProjectsActionBlockPaymentActionBlock", LazyPagesProjectsActionBlockPaymentActionBlock],
["PagesProjectsActionBlockPaymentPendingBlock", LazyPagesProjectsActionBlockPaymentPendingBlock],
["PagesProjectsActionBlockPromocodeModalButton", LazyPagesProjectsActionBlockPromocodeModalButton],
["PagesProjectsContentProjectContent", LazyPagesProjectsContentProjectContent],
["PagesProjectsContentProjectContentItem", LazyPagesProjectsContentProjectContentItem],
["PagesProjectsContentProjectContentTitle", LazyPagesProjectsContentProjectContentTitle],
["PagesProjectsContentRu", LazyPagesProjectsContentRu],
["PagesProjectsContentVariantsContentBlurred", LazyPagesProjectsContentVariantsContentBlurred],
["PagesProjectsContentVariantsContentEditable", LazyPagesProjectsContentVariantsContentEditable],
["PagesProjectsContentVariantsContentGenerating", LazyPagesProjectsContentVariantsContentGenerating],
["PagesProjectsContentVariantsContentText", LazyPagesProjectsContentVariantsContentText],
["PagesProjectsContentVariantsEditorjsToolsEditorJsMath", LazyPagesProjectsContentVariantsEditorjsToolsEditorJsMath],
["PagesProjectsContentVariantsEditorjsToolsEditorJsMathTool", LazyPagesProjectsContentVariantsEditorjsToolsEditorJsMathTool],
["PagesProjectsContentList", LazyPagesProjectsContentList],
["PagesProjectsContentListItem", LazyPagesProjectsContentListItem],
["PagesProjectsContentListButtonsContentListItemLeftButtons", LazyPagesProjectsContentListButtonsContentListItemLeftButtons],
["PagesProjectsContentListButtonsContentListItemRightButtons", LazyPagesProjectsContentListButtonsContentListItemRightButtons],
["PagesProjectsContentListModalsContentListAddModal", LazyPagesProjectsContentListModalsContentListAddModal],
["PagesProjectsContentListModalsContentListDeleteModal", LazyPagesProjectsContentListModalsContentListDeleteModal],
["PagesProjectsContentListModalsContentListLastParagraphWarning", LazyPagesProjectsContentListModalsContentListLastParagraphWarning],
["PagesProjectsContentListModalsContentListRegenerateModal", LazyPagesProjectsContentListModalsContentListRegenerateModal],
["PagesProjectsContentListTypes", LazyPagesProjectsContentListTypes],
["PagesProjectsDownloadButtonsDownloadDocument", LazyPagesProjectsDownloadButtonsDownloadDocument],
["PagesProjectsDownloadButtonsDownloadPresentation", LazyPagesProjectsDownloadButtonsDownloadPresentation],
["PagesProjectsPaymentCopyButton", LazyPagesProjectsPaymentCopyButton],
["PagesProjectsPaymentNewPaymentButton", LazyPagesProjectsPaymentNewPaymentButton],
["PagesProjectsPaymentButton", LazyPagesProjectsPaymentButton],
["PagesProjectsPaymentDropdownButton", LazyPagesProjectsPaymentDropdownButton],
["PagesProjectsPaymentErrorModal", LazyPagesProjectsPaymentErrorModal],
["PagesProjectsPaymentBonusesButton", LazyPagesProjectsPaymentBonusesButton],
["PagesProjectsPaymentBonusesModal", LazyPagesProjectsPaymentBonusesModal],
["PromoRefundDetailsPopup", LazyPromoRefundDetailsPopup],
["RatingRateModal", LazyRatingRateModal],
["RatingReviewRating", LazyRatingReviewRating],
["RatingSorryModal", LazyRatingSorryModal],
["RatingStarRatingIconStar", LazyRatingStarRatingIconStar],
["RatingStarRatingOtzovikModal", LazyRatingStarRatingOtzovikModal],
["RatingStarRating", LazyRatingStarRating],
["TopicsSubjectTopics", LazyTopicsSubjectTopics],
["TopicsVTopics", LazyTopicsVTopics],
["UserAccountModal", LazyUserAccountModal],
["UserDeleteRequest", LazyUserDeleteRequest],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
